// Svg
import { Inspiration, Access, Skips, WorldOfInspirers, Unlock, Support } from '../../assets'

export const whatYouGet = [
  {
    id: 1,
    title: 'Daily Inspiration',
    description: 'Curated Raylists with the right words, at the right time designed around what serves you most',
    icon: <Inspiration />,
  },
  {
    id: 2,
    title: 'Access to All Raylists',
    description: 'Unlock exclusive access to our whole library',
    icon: <Access />,
  },
  {
    id: 3,
    title: 'Unlimited Skips',
    description: 'Move freely through your Presence content',
    icon: <Skips />,
  },
  {
    id: 4,
    title: 'Access a world of inspirers',
    description: 'Find who inspires you the most and enjoy the diversity of their ideas',
    icon: <WorldOfInspirers />,
  },
  {
    id: 5,
    title: 'Unlock Favorites',
    description: 'Save everything you love to enjoy it any time',
    icon: <Unlock />,
  },
  {
    id: 6,
    title: 'World Class Support',
    description:
      'Superior support from a team that is dedicated to the transformative capabilities of merging tech with mindfulness',
    icon: <Support />,
  },
]
